import styled, { css } from 'styled-components'
import { H1, P, Span } from '../../../shared_components/Library/Typeography'
import {
  setBottomNavButton,
  setDismissableModal,
} from '../../../modules/miscUi/actions'
import { ThemedButton } from '../../../shared_components/ThemedButton'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectCurrentSeason,
  selectCurrentSeasonProgress,
  selectRecentlyCompletedQuests,
} from '../../../modules/seasons/selectors'
import { Box } from '../../../shared_components/UI/Box'
import { TopVideo } from './About'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'
import { QuestsContainer, QuestWithProgressCard } from './Progress'
import { ScrollableModalButtonProps } from './About'
import AnimatedLoader from '../../../shared_components/AnimatedLoader'
import { Seperator } from '../../Memecoins/TokenPage/Threads/ThreadList'
import { setRecentlyCompletedQuests } from '../../../modules/seasons/slice'

export default function QuestComplete() {
  const dispatch = useDispatch()

  const recentlyCompletedQuests = useSelector(selectRecentlyCompletedQuests)

  function dismissModal() {
    dispatch(setDismissableModal(null))
  }

  useEffect(() => {
    if (!dispatch) return
    return () => {
      dispatch(setRecentlyCompletedQuests([]))
    }
  }, [dispatch])

  const quests = useSelector(selectCurrentSeason).meta_data.quests
  const currentSeasonProgress = useSelector(selectCurrentSeasonProgress)

  if (!quests || !currentSeasonProgress) return <AnimatedLoader />

  const questsById = quests.reduce((acc, quest) => {
    acc[quest.questId] = quest
    return acc
  }, {})

  const seasonProgressById = currentSeasonProgress.quests.reduce(
    (acc, quest) => {
      acc[quest.questId] = quest
      return acc
    },
    {},
  )

  return (
    <>
      <Container dc>
        <QuestCompleteBackdrop />
        <Box dc g={12}>
          <Box jsb ac>
            <BottomHolder c dc g={8}>
              <H1 s="XL" fw="semibold">
                QUEST COMPLETE
              </H1>
            </BottomHolder>
          </Box>
        </Box>
        <Seperator />
        <Box c dc g={16} flex={0}>
          {recentlyCompletedQuests.map((quest) => (
            <QuestWithProgressCard
              isCompact
              quest={{
                ...questsById[quest.questId],
                ...seasonProgressById[quest.questId],
                oldProgress: quest.oldProgress,
              }}
            />
          ))}
        </Box>
      </Container>
      <ButtonContainer>
        <ThemedButton $styleType="primary" w="100%" onClick={dismissModal}>
          Continue
        </ThemedButton>
      </ButtonContainer>
    </>
  )
}

const ButtonContainer = styled(Box)`
  border-bottom-left-radius: var(--units-12, 12px);
  border-bottom-right-radius: var(--units-12, 12px);
  border-top: 1px solid var(--stroke-secondary, #333);
  padding: 16px;
  background: linear-gradient(
      0deg,
      var(--surface-minimal-alpha-primary, rgba(255, 255, 255, 0.04)) 0%,
      var(--surface-minimal-alpha-primary, rgba(255, 255, 255, 0.04)) 100%
    ),
    var(--surface-primary, #080808);
`

export const questBackdrop = css`
  background-image: url('/img/quest-complete-backdrop.svg');
  background-size: cover;
`

export const brighterQuestBackdrop = css`
  background-image: url('/img/quest-complete-backdrop-brighter.svg');
  background-size: cover;
  background-position: center;
`

export const QuestCompleteBackdrop = styled(Box)`
  ${brighterQuestBackdrop}
  min-height: 200px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.compact}px) {
    min-height: 100px;
  }
`

const BottomHolder = styled(Box)`
  text-align: center;
`

export function SeasonVideoBanner() {
  const { videoUrl } = useSelector(selectCurrentSeason)
  return (
    <TopVideo autoPlay loop muted>
      <source src={videoUrl} type="video/mp4" />
      Your browser does not support the video tag.
    </TopVideo>
  )
}

export function AcknowledgeQuestCompleteButton({
  continueScrolling,
  moreToScroll,
}: ScrollableModalButtonProps) {
  const history = useHistory()
  const dispatch = useDispatch()
  function dismissBottomButton() {
    dispatch(setBottomNavButton(null))
  }
  function handleBackNav() {
    history.goBack()
    dismissBottomButton()
  }
  function handleViewSeason() {
    history.push('/season')
    dismissBottomButton()
  }
  const canScroll = moreToScroll && continueScrolling
  return (
    <Box dc g={16} c padV={12}>
      <ThemedButton $styleType="primary" w="100%" onClick={handleBackNav}>
        Continue
      </ThemedButton>
      <Span
        s="L"
        c="text-brandPrimary"
        fw="semibold"
        style={{ cursor: 'pointer' }}
        onClick={canScroll ? continueScrolling : handleViewSeason}
      >
        {canScroll ? 'Continue' : 'View Season'}
      </Span>
    </Box>
  )
}

const Container = styled(Box)`
padding: 16px;
gap: var(--Spacing-Padding-L, 20px);
${Seperator} {
    margin: 0 !important;
    opacity: 1;
    background: var(--stroke-tertiary, #252525);
  }
}
`
